const defaultState = {
    userId: null,
    loggedIn: false,
    language: 'en'
};

export const userReducer = (state = defaultState, action) => {
    switch (action) {
        default:
            return state;
    }
};
